import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="10"
    viewBox="0 0 15 10"
  >
    <path
      fillRule="evenodd"
      d="M12.5.808l1.5 1.5-6.5 6.5-6.5-6.5 1.5-1.5 5 5z"
    />
  </svg>
);
